// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"style_toolbar__2dB4u","content":"style_content__1CXxF"};